export default __webpack_public_path__ + "static/media/autodesk.33ce08e2.png";